/* eslint-disable */
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

const StoryPaymentConvertData = (inputData: any) => {
 let outPutArray: any = [];

 if (!inputData || inputData.length === 0) {
  return [];
 }

 let counter = 0;

 if (inputData && inputData.length > 0) {
  inputData.map((record: any) => {
   const recordNumber = counter + 1;
   const status = 'Принят';

   let newRecord = { ...cloneDeep(record), recordNumber, status };
   if (newRecord.status) {
    let value = 'Принят';
    newRecord.status = value;
   }

   newRecord.objectId = record?.objectId ?? record?.id ?? null;

   outPutArray.push(newRecord);
   counter++;
  });

  return outPutArray;
 }

 return [];
};

export { StoryPaymentConvertData };
